import React,{useState,useEffect,forwardRef,} from 'react'
import "./TemplateMapping.css"
import Select from "react-select";
import auditbreadcrumb_icon from "../../../assets/audit_assets/Create_Audit/auditbreadcrumb_icon.png"
import { HiOutlineOfficeBuilding, HiOutlineIdentification, HiOutlineTemplate, HiOutlinePuzzle, HiOutlineMenuAlt2 } from "react-icons/hi";
import selected_icon from '../../../assets/reUsableTemplates_assets/selected_icon.png';
import arrow_up from "../../../assets/audit_assets/Audit_reusable_table/arrow_up.png"
import arrow_down from "../../../assets/audit_assets/Audit_reusable_table/arrow_down.png"
import action_icon from "../../../assets/audit_assets/Audit_reusable_table/action.png"
import { GoChevronRight } from "react-icons/go";
import intomarkIcon from "../../../assets/audit_assets/Audit_vendor/intomarkIcon.png"
import {getClientMapping,createSingleClientMapping,multiDeleteClientMapping,updateClientMappingById,deleteClientMappingById} from '../../../services/audit_redux/audit_actions/TemplateMap.action';
import { getClients} from '../../../services/global_redux/globale_actions/Client.action';
import {getTemplate} from '../../../services/global_redux/globale_actions/ActRuleActivity.action'
import table_delete_icon from "../../../assets/reUsableTemplates_assets/table_delete_icon.png"
import table_edit_icon from "../../../assets/reUsableTemplates_assets/table_edit_icon.png"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { useDispatch } from 'react-redux';
import MultiSelect from '../../reUsableTemplates/multiSelectDropdown/MultiSelect';
import { getUserRole} from "./../../../services/global_redux/globale_actions/Role.action"
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function TemplateMapping({setLoading,showSnackbar}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [checkedItemCount, setCheckedItemCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [openeditalert, setOpeneditalert] = useState(false);
  const [createSingleTemplate,setCreateSingleTemplate] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [clientData,setClientData] = useState([]);
  const [opendeletealert, setopendeletealert] = useState(false);
  const [deletesingleID, setdeletesingleID] = useState("");
  const [updateMap, setUpdateMap] = useState("");
  const [templatedata, setTemplatedata] = useState([]);
  const [createOrUpdateform, setCreateOrUpdateform] = useState("Create");
  const [allClient, setAllClient] = useState([]);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [checkCreate, setCheckCreate] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [checkDelete, setCheckDelete] = useState(false);
  const [actionChecked, setActionChecked] = useState("");
  const createMapTemplateData = {
    client_id:'',
    client_name:'',
    templates:[],
  }
  const [createMapTemplate,setCreateMapTemplate] = useState(createMapTemplateData);
  const dispatch = useDispatch();

  const header = [
    { key: "client_name", value: "Organization Name", Icon: HiOutlineOfficeBuilding },
    { key: "client_id", value: "Organization ID", Icon: HiOutlineIdentification },
    { key: "templates", value: "Templates", Icon: HiOutlineTemplate }
  ];
  const fetchTemplate = async () =>{
    try {
      const response = await dispatch(getTemplate());
      if (response.success) {
        setTemplatedata(response.data);
      }else{
        setTemplatedata([]);
      }
    } catch (err) {
        console.error("Failed to fetch:", err);
    }
  }
  const templateOptions = templatedata.map((item) => ({
    value: item.templateId,
    label: item.templateName,
  }));
  const fatchClient = async ()=>{
    try {
        const response = await dispatch(getClients());
        if (response.success) {
              setClientData(response.data);
              setAllClient(response.data);
        }else{
          setClientData([]);
          setAllClient([]);
        }
    } catch (err) {
        console.error("Failed to fetch clients:", err);
    }

  }
  useEffect(()=>{
    if(allClient.length > 0 && data.length > 0){
      const tempClients = data.map((item)=>item.client_id);
      const finalClientData = clientData.filter((item)=>!tempClients.includes(item.client_id));
      setClientData(finalClientData);
    }
  },[data,allClient])
  useEffect(()=>{
    fetchTemplate();
    fetchData();
    fatchClient();
  },[dispatch])
  const handleCheckAll = (e) => {
    const checked = e.target.checked;
    setIsAllChecked(checked);
  
    const newCheckedItems = { ...checkedItems };
    currentRecords.forEach((item) => {
      newCheckedItems[item.id] = checked;
    });
  
    setCheckedItems(newCheckedItems);
  };

  
  const handleSort = (key) => {
    setSortConfig((prev) => ({
        key,
        direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
};

const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.direction === "asc" ? arrow_up : arrow_down;
};
const filteredData = Array.isArray(data)
? data.filter(item =>
    Object.values(item).some(value =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  )
: [];
useEffect(() => {
  setCurrentPage(1);
 },[searchQuery]);
const sortedData = [...filteredData].sort((a, b) => {
  if (!sortConfig.key) return 0;
  const aVal = a[sortConfig.key];
  const bVal = b[sortConfig.key];
  if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
  if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
  return 0;
});
  // pagination
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(sortedData.length / recordsPerPage);
  const handlePageChange = (pageNumber) => {
      if (pageNumber >= 1 && pageNumber <= totalPages) {
          setCurrentPage(pageNumber);
      }
  };
  
  const fetchData = async (type)=>{
    try {
        const response = await dispatch(getClientMapping());
        if (response.success) {
          setData(response.data);
          setActionChecked(type);          
        }else{
          setData([]);
        }
    } catch (err) {
        console.error("Failed to fetch:", err);
    }

  }
  useEffect(()=>{
    if(actionChecked === "create"){
        setCurrentPage(totalPages);
      setActionChecked("");

    }else if(actionChecked === "delete"){
      if(currentPage != 1 && currentPage > totalPages){
        setCurrentPage(totalPages);
      setActionChecked("");
      }
    }else{
      setActionChecked("");
    }
  },[actionChecked,totalPages])
  const getPageSizeOptions = (totalEntries) => {
    const options = [ 10, 20, 50, 100,200,300,400,500,600];
    const filtered = options.filter(size => size < totalEntries);
  
    return [...filtered, totalEntries];
  };
  const handleCheckChange = (id) => {
    setCheckedItems(prevCheckedItems => ({
        ...prevCheckedItems,
        [id]: !prevCheckedItems[id]
    }));
  };
  
  
const CreateClinetMappingSubmit = async(e) => {
  e.preventDefault();
  setLoading(true);
  try{
    const response = await dispatch(createSingleClientMapping(createMapTemplate));
    if(response.success){
      fetchData("create");
      setCreateSingleTemplate(false)
      setCreateMapTemplate(createMapTemplateData)
      setLoading(false);
      showSnackbar(response.message.message,'success');
    }else{
      setLoading(false);
      showSnackbar(response.message.message,'warning');

    }
  }catch(err){
    setLoading(false);
    console.error('something went wrong',err)
  }

};

const opencreateSingle = () =>{
  setCreateSingleTemplate(true)
  setCreateMapTemplate(createMapTemplateData)
  setCreateOrUpdateform('Create');
}


const handledeletealert = (id) => {
  setopendeletealert(true)
  setdeletesingleID(id)
}
const handledeleteClickconfirmed = async() => {
    setopendeletealert(false)
    setLoading(true);
    try{
      const response = await dispatch(deleteClientMappingById(deletesingleID));
      if(response.success){
      fetchData("delete");
        setLoading(false);
        showSnackbar(response.message,'success');

      }else{
        setLoading(false);
        showSnackbar(response.message,'warning');

      }
    }catch(err){
      setLoading(false);
      console.error("something went wrong",err)
    }
    
}
const handledeleteClosealert = () => {
    setopendeletealert(false)
}

const handleEditClick = (id) => {
  const item = data.find(d => d.id === id);
  setUpdateMap(item?.id);
  setCreateMapTemplate({
    client_id: item?.client_id,
    client_name: item?.client_name,
    templates: item.templates?.map(opt => ({
      template_id: opt.template_id,
      templateName: opt.template_name
    })),
    id:item?.id,
  })
  
  setCreateSingleTemplate(true)
  setCreateOrUpdateform('Update');
};

const UpdateClinetMappingSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try{
    const response = await dispatch(updateClientMappingById(createMapTemplate.id,createMapTemplate));
    if(response.success){
      fetchData();
      setCreateSingleTemplate(false)
      setCreateMapTemplate(createMapTemplateData)
      setLoading(false);
      showSnackbar(response.message,'success');
    }else{
      setLoading(false);
      showSnackbar(response.message,'warning');
    }
  }catch(err){
    setLoading(false);
    console.error("something went wrong",err)
  }

}

const getUserPermission = async () => {
    try {
        const response = await dispatch(getUserRole());
            const rawPermissions = response?.data?.permissions;
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                ? JSON.parse(rawPermissions[0])
                : rawPermissions;
            parsedPermissions.forEach((item) => {
              if (item.section == "Configuration" && item.module == "Template Mapping") {
                setCheckCreate(item.action.create);
                setCheckEdit(item.action.edit);
                setCheckDelete(item.action.delete);
              }})

    } catch (err) {
      console.error("Failed to fetch states:", err);
    }

};
useEffect(() => {
  getUserPermission();
}, [dispatch]);
  return (
    <div className='container-fluid'>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="create-audit-header d-flex ">
          <img src={auditbreadcrumb_icon} alt="" /><h5 className='breadcrumbdata text-white'>Configuration <span><GoChevronRight /></span> Template Mapping</h5>
          </div>
            <div className="row">
              <div className={`container-fluid vendorEditableTable-main-contaner`}>
                <div className='row FormsTable-main'>
                    <div className="table-header">
                      <div className="row d-flex">
                          {/* <form onSubmit={handledeletemultialert} className='p-0 m-0'> */}
                            <div className="col d-flex justify-content-between  pe-1">
                              <div className="title-data d-flex"><div className="table_main_img template-mapping-title-icon">
                              <HiOutlinePuzzle className="tableTitleSvgIcon" aria-hidden="true" />
                              </div>
                                <p className="dataTitle">Template Mapping</p> 
                                <div className="FormsTable-search-box position-relative">
                                  <input
                                    type="text"
                                    className=""
                                    placeholder="Search here..."
                                    style={{
                                      backgroundColor: "#f9fafb",
                                      border: "none",
                                      width: "250px"
                                    }}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                  />
                                  <i
                                    className="bi bi-search position-absolute"
                                    style={{
                                      top: "39%",
                                      left: "20px",
                                      transform: "translateY(-50%)",
                                      color: "#9ca3af"
                                    }}
                                  ></i>
                                </div>
                              </div>
                              <div className='float-end d-flex'>
                                <div className="dataTotalEntries"><p>Total Entries :{data?.length}</p></div>
                                <div className="filter_or_createcomponentn">
                                  {checkCreate &&
                                  <button
                                  onClick={opencreateSingle}
                                   >Map template for Organization</button>
                                   }
                                </div>
                              </div>
                            </div>
                            <div className={`table-body bg-white p-0`}>
                              <div
                              className={`table-responsive reuseableEditable is-scrollable-table template-mapping-table`} >
                                <table className='table p-0 m-0' id='dataTable'>
                                  <thead>
                                    <tr>
                                      <th className='slno'>
                                        <HiOutlineMenuAlt2 className="headerIcon headerSvgIcon" aria-hidden="true" />
                                        SL No.
                                      </th>
                                      {header?.map((headerItem) => (
                                        <th
                                            key={headerItem.key}
                                            onClick={() => handleSort(headerItem.key)}
                                        >
                                          {headerItem.Icon ? (
                                            <headerItem.Icon className="headerIcon headerSvgIcon" aria-hidden="true" />
                                          ) : headerItem.icon ? (
                                            <img src={headerItem.icon} alt="" className='headerIcon' />
                                          ) : null} {headerItem.value === "Client ID"? "Org ID":headerItem.value} {getSortIcon(headerItem.key) &&<img src={getSortIcon(headerItem.key)} alt="" className='arrow_img'/>}
                                        </th>
                                      ))}
                                      { checkEdit || checkDelete ?
                                        <th className='action_dataIconheader'><img src={action_icon} alt="noImg" className='headerIcon' />Action</th>:<></>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {currentRecords.length > 0 ? (
                                      currentRecords.map((item, index) => (
                                        <tr key={item.id} data-id={item.id}>
                                          <td className="tabletdheight slno" >
                                            <div className="table-td-div mt-1">
                                              {indexOfFirstRecord + index + 1}
                                            </div>
                                          </td>

                                          {header.map((headerItem) => (
                                            
                                            <td key={headerItem.key} className="tabletdheight">
                                              {Array.isArray(item[headerItem.key])
                                              ? item[headerItem.key].map((item)=>item.template_name).join(', ')
                                              : item[headerItem.key]}
                                            </td>
                                          ))}
                                        
                                        { checkEdit === true || checkDelete === true  ?
                                          <td>
                                            <div className="d-flex ">
                                              {checkEdit === true &&
                                                <span
                                                  onClick={() => handleEditClick(item.id)}
                                                  className=" p-0"
                                                >
                                                  <div className="action_icon action_edit_icon"><img src={table_edit_icon} alt="" className='edit_icon'/></div>
                                                </span>
                                              }
                                              {checkDelete === true &&
                                                <span
                                                  onClick={() => handledeletealert(item.id)}
                                                  className=" p-0"
                                                >
                                                  <div className="action_icon action_delete_icon"><img src={table_delete_icon} alt="" className='delete_icon'/></div>
                                                </span>
                                              }
                                            </div>
                                          </td>:<></>
                                        }   
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={header.length + 2}
                                          className="text-center fs-3 fw-bold text-muted"
                                        >
                                          No Record Available
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>

                                </table>
                              </div>
                              </div>
                            {/* </form> */}
                        <div className="col-md-12">
                        <div className="pagination align-items-center justify-content-between mt-3 row">
                          <div className="col-md-12 text-center">
                          <div>
                            {/* Prev button */}
                            <button
                              className="page-btn-arrow"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              &lt;
                            </button>

                            {(() => {
                              const pages = [];

                              if (totalPages <= 10) {
                                for (let i = 1; i <= totalPages; i++) {
                                  pages.push(i);
                                }
                              } else {
                                pages.push(1); // Always show first

                                // Left ellipsis
                                if (currentPage > 4) {
                                  pages.push("...");
                                }

                                // Sliding window around current page
                                const start = Math.max(2, currentPage - 2);
                                const end = Math.min(totalPages - 1, currentPage + 2);

                                for (let i = start; i <= end; i++) {
                                  pages.push(i);
                                }

                                // Right ellipsis
                                if (currentPage < totalPages - 3) {
                                  pages.push("...");
                                }

                                pages.push(totalPages); // Always show last
                              }

                              return pages.map((p, idx) =>
                                p === "..." ? (
                                  <span key={`ellipsis-${idx}`} className="ellipsis">
                                    ...
                                  </span>
                                ) : (
                                  <button
                                    key={p}
                                    className={`page-btn ${currentPage === p ? "active" : ""}`}
                                    onClick={() => handlePageChange(p)}
                                  >
                                    {p}
                                  </button>
                                )
                              );
                            })()}

                            {/* Next button */}
                            <button
                              className="page-btn-arrow"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              &gt;
                            </button>
                          </div>

                          </div>

                          <div className="col-md-12">
                          <div className="row float-end">
                          <div className="d-flex align-items-center showPerPage">
                            <span className="me-2">Show per page:</span>
                            <select
                              value={recordsPerPage}
                              onChange={(e) => {
                                setRecordsPerPage(Number(e.target.value));
                                setCurrentPage(1);
                              }}
                            >
                              {getPageSizeOptions(sortedData.length).map((size, i) => (
                                <option key={i} value={size}>
                                  {size === sortedData.length ? "All" : size}
                                </option>
                              ))}
                            </select>
                          </div>
                          </div>
                          </div>
                        </div>
                        </div>

                      </div>
                    </div>
                </div>
    {createSingleTemplate && (

      <>
    <div className="createTemplateMappingContainerd">
      {createOrUpdateform === "Create" ?<>
      <div className="createTemplateMappingContainerd-module shadow">
        <div className="create-TemplateMapping-header d-flex justify-content-between">
          <div className="div">
            <h5>Map Template to Organization</h5>
            <p>
              Assign templates to the organization to ensure consistent and compliant audit execution.
            </p>
          </div>
          <button
            className="into-btn-icon"
            onClick={() => setCreateSingleTemplate(false)}
          >
          <img src={intomarkIcon} alt="" />
          </button>
        </div>

        <div className="">
          <div className="container mt-2">
            <div className="form-container">
              <form onSubmit={CreateClinetMappingSubmit}>
                
                  <>
                  
                  <div className="row templateMapping-form">
                    <div className="col-md-12">
                      <label>Organization Name</label>
                      <select className="form-control"
                       value={createMapTemplate.client_id} 
                       required
                       onChange={(e) =>{
                        const client_id_value = e.target.value
                        const client_name_value = clientData.find(c => c.client_id == client_id_value);
                        setCreateMapTemplate({
                          ...createMapTemplate,
                          client_id: client_id_value,
                          client_name:client_name_value?.client_name,
                        })
                       }}
                       >
                        <option value="">--select--</option>
                        {clientData?.map((item) => (
                          <option key={item.client_id} value={item.client_id}>
                            {item.client_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-12">
                      <label>Templates</label>
                      {/* <Select
                        isMulti
                        required
                        options={templateOptions}
                        value={createMapTemplate.templates?.map(t => ({
                          value: t.template_id,
                          label: t.templateName
                        }))}
                        onChange={(selectedOptions) =>
                          setCreateMapTemplate({
                            ...createMapTemplate,
                            templates: selectedOptions.map(opt => ({
                              template_id: opt.value,
                              templateName: opt.label
                            }))
                          })
                        }
                        placeholder="Select templates..."
                        classNamePrefix="react-select"
                      /> */}
                      <MultiSelect
                        id="template-select"
                        options={templateOptions}
                        
                        value={createMapTemplate.templates?.map(t => t.template_id) || []}

                        onChange={(selectedValues) => {
                          setCreateMapTemplate({
                            ...createMapTemplate,
                            templates: selectedValues.map(val => {
                              const match = templateOptions.find(o => o.value === val);
                              return {
                                template_id: val,
                                templateName: match?.label || ""
                              };
                            })
                          });
                        }}

                        openDropdownId={openDropdownId}
                        setOpenDropdownId={setOpenDropdownId}
                        placeholder="Select templates..."
                      />

                    </div>
                  </div>


                    <div className="text-end mt-3">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary px-4"
                      >
                        submit
                      </button>
                    </div>
                  </>
              </form>
            </div>
          </div>
        </div>
      </div>

      </>:<>
      
      <div className="createTemplateMappingContainerd-module shadow">
        <div className="create-TemplateMapping-header d-flex justify-content-between">
          <div className="div">
            <h5>Update Template for Organization</h5>
            <p>
              Modify and manage templates assigned to the organization with accuracy and control.
            </p>
          </div>
          <button
            className="into-btn-icon"
            onClick={() => setCreateSingleTemplate(false)}
          >
          <img src={intomarkIcon} alt="" />
          </button>
        </div>

        <div className="">
          <div className="container mt-2">
            <div className="form-container">
              <form onSubmit={UpdateClinetMappingSubmit}>
                
                  <>
                  
                  <div className="row templateMapping-form">
                    <div className="col-md-12">
                      <label>Organization Name</label>
                      {/* <select className="form-control"
                       value={createMapTemplate.client_name}
                       onChange={(e) =>
                         setCreateMapTemplate({
                           ...createMapTemplate,
                           client_id: e.target.value,
                         })
                       }
                       disabled
                       >
                        <option value="">--select--</option>
                        {clientData?.map((item) => (
                          <option key={item.client_id} value={item.client_id}>
                            {item.client_name}
                          </option>
                        ))}
                      </select> */}
                      <input type="text" name="" id="" className="form-control" value={createMapTemplate.client_name}  readOnly/>
                    </div>

                    <div className="col-md-12">
                      <label>Templates</label>
                      <Select
                        isMulti
                        required
                        options={templateOptions}
                        value={createMapTemplate.templates?.map(t => ({
                          value: t.template_id,
                          label: t.templateName
                        }))}
                        onChange={(selectedOptions) =>
                          setCreateMapTemplate({
                            ...createMapTemplate,
                            templates: selectedOptions.map(opt => ({
                              template_id: opt.value,
                              templateName: opt.label
                            }))
                          })
                        }
                        placeholder="Select templates..."
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>


                    <div className="text-end mt-3 " style={{ }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary px-4 me-4"
                        onClick={() => setCreateSingleTemplate(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-sm btn-success px-4"
                      >
                        Update
                      </button>
                    </div>
                  </>
              </form>
            </div>
          </div>
        </div>
      </div>
      </>}
    </div>

      </>
    )}
                <Dialog
                    open={opendeletealert}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Are you sure?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Are you sure you want to delete this Record? This action cannot be undone.

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handledeleteClosealert}>No</Button>
                        <Button onClick={handledeleteClickconfirmed}>Yes</Button>
                    </DialogActions>
                </Dialog>
                {/* <Dialog
                    open={openeditalert}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Are you sure?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Are you sure you want to edit this Record ? Any unsaved changes might be lost.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseeditalert}>No</Button>
                        <Button onClick={handleSaveClickconfirmed}>Yes</Button>
                    </DialogActions>
                </Dialog>
                
                <Dialog
                    open={opendeletemultialert}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Are you sure?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Are you sure you want to delete those Record ? This action cannot be undone.

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handledeletemultiClosealert}>No</Button>
                        <Button onClick={selectedDelete}>Yes</Button>
                    </DialogActions>
                </Dialog> */}
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default TemplateMapping